import { Injectable } from '@angular/core';
import { scrollActiveInputIntoView } from '@shared/utils/scroll-active-input-into-view';

@Injectable({
  providedIn: 'root',
})
export class KeyboardService {
  keepActiveInputInViewOnKeyboardOpen(): void {
    window.visualViewport?.addEventListener('resize', () => {
      setTimeout(() => {
        scrollActiveInputIntoView();
      }, 300);
    });
  }
}
